/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Last_ActiveInputs */



/**
* | output |
* | --- |
* | "Last active" |
*
* @param {User_List_Last_ActiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_last_active = /** @type {((inputs?: User_List_Last_ActiveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Last_ActiveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dernière activité")
	if (locale === "es") return /** @type {LocalizedString} */ ("Última actividad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Última atividade")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultima attività")
	return /** @type {LocalizedString} */ ("Last active")
});